<!-- 添加优惠券弹窗组件 -->
<template>
  <a-modal
    :maskClosable="false"
    v-model="visible"
    width="600px"
    title="添加优惠券"
    :confirm-loading="submitLoading"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <a-form-model
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="rules"
      ref="formModel"
      size="small"
      :model="form"
    >
      <a-form-model-item label="商品名称">
        <a-input :value="goodsData.goods_name" disabled />
      </a-form-model-item>

      <a-form-model-item label="优惠券名称" prop="coupon_name">
        <a-input placeholder="请输入优惠券名称" v-model="form.coupon_name" />
      </a-form-model-item>

      <a-form-model-item label="优惠类型" prop="type">
        <a-select
          v-model="form.type"
          placeholder="请选择优惠类型"
          @change="onCouponTypeChange"
        >
          <a-select-option :value="1">满减</a-select-option>
          <a-select-option :value="3">折扣</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="优惠金额" prop="amount" v-if="form.type === 1">
        <a-input-number
          placeholder="请输入优惠金额"
          v-model="form.amount"
          :min="0"
          :precision="2"
          style="width: 100%"
        />
        <div class="fs12 color666">满减金额，单位：元</div>
      </a-form-model-item>

      <a-form-model-item label="折扣比例" prop="amount" v-if="form.type === 3">
        <a-input-number
          placeholder="请输入折扣比例"
          v-model="form.amount"
          :min="0.1"
          :max="1"
          :step="0.01"
          :precision="2"
          style="width: 100%"
        />
        <div class="fs12 color666">折扣比例，如95折输入0.95，五折输入0.5</div>
      </a-form-model-item>

      <a-form-model-item label="使用条件" prop="condition">
        <a-input-number
          placeholder="请输入满减条件"
          v-model="form.condition"
          :min="0"
          :precision="2"
          style="width: 100%"
        />
        <div class="fs12 color666">满减金额条件，单位：元，0表示无门槛</div>
      </a-form-model-item>

      <a-form-model-item label="有效期" prop="dateRange">
        <a-range-picker
          v-model="form.dateRange"
          format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD"
          placeholder="['开始日期', '结束日期']"
          style="width: 100%"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { Coupon_add } from "@/api/goods";

export default {
  name: "AddCouponModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    goodsData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitLoading: false,
      form: {
        coupon_name: "",
        amount: "",
        target_id: 0,
        start_date: "",
        end_date: "",
        type: 1,
        condition: "",
        dateRange: [],
      },
      rules: {
        coupon_name: [
          { required: true, message: "请输入优惠券名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择优惠类型", trigger: "change" },
        ],
        amount: [
          {
            required: true,
            message: "请输入优惠金额或折扣比例",
            trigger: "blur",
          },
        ],
        condition: [
          { required: true, message: "请输入使用条件", trigger: "blur" },
        ],
        dateRange: [
          { required: true, message: "请选择有效期", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    // 初始化表单
    initForm() {
      this.form = {
        coupon_name: "",
        amount: "",
        target_id: this.goodsData.id,
        start_date: "",
        end_date: "",
        type: 1,
        condition: "",
        dateRange: [],
      };
    },

    // 优惠券类型变化处理
    onCouponTypeChange(type) {
      // 切换类型时清空金额，不设置默认值
      this.form.amount = undefined;
    },

    // 取消弹窗
    handleCancel() {
      this.submitLoading = false;
      this.visible = false;
      this.resetForm();
      this.$emit("cancel");
    },

    // 重置表单
    resetForm() {
      this.form = {
        coupon_name: "",
        amount: "",
        target_id: 0,
        start_date: "",
        end_date: "",
        type: 1,
        condition: "",
        dateRange: [],
      };
    },

    // 提交表单
    async onSubmit() {
      this.$refs.formModel.validate(async (valid) => {
        if (valid) {
          if (!this.form.dateRange || this.form.dateRange.length !== 2) {
            this.$message.warning("请选择有效期");
            return;
          }

          this.submitLoading = true;

          try {
            const params = {
              coupon_name: this.form.coupon_name,
              amount: this.form.amount,
              target_id: this.form.target_id,
              start_date: this.form.dateRange[0],
              end_date: this.form.dateRange[1],
              type: this.form.type,
              condition: this.form.condition,
            };

            await Coupon_add(params);
            this.$message.success("优惠券添加成功");

            setTimeout(() => {
              this.submitLoading = false;
              this.visible = false;
              this.resetForm();
              this.$emit("success");
            }, 1500);
          } catch (error) {
            this.submitLoading = false;
            console.error("添加优惠券失败:", error);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script> 